import React, { Component } from "react";
import Modal from "@material-ui/core/Modal";
import ProfileService from "services/profile/ProfileService";
import MessageBox from "components/Box/MessageBox";
import { translate } from "react-i18next";

class ModalPrivacy extends Component {
  state = {
    isOpen: this.props.isOpen,
    termsOfUse: "",
  };

  async componentDidMount() {
    const profile = new ProfileService(true);
    const dataTerms = await profile.getTermsOfUse();
    this.setState({
      termsOfUse: dataTerms.termsOfUse[0].privacy,
    });
  }

  createMarkup(terms) {
    return { __html: terms };
  }

  refuse() {
    const { t } = this.props;
    this.refs.instMessageBox.open(<div>{t("privacy.acceptTermsToUse")}</div>);
  }

  confirm(e) {
    const profile = new ProfileService(true);
    profile.insertAcceptTermsOfUse();
    localStorage.setItem("ACCEPTY_PRIVACY", 1);
    this.setState({ isOpen: false });
    if (this.props.onAccept) {
      this.props.onAccept();
    }
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        open={this.state.isOpen}
        disableBackdropClick={true}
        style={{ width: "100%", backgroundColor: "#333" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            padding: "10px",
          }}
        >
          <div
            style={{
              backgroundColor: "#FFF",
              width: "100%",
              maxWidth: "500px",
              margin: "10px",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "left",
                alignItems: "left",
                fontSize: "15px",
                fontWeight: "bold",
                padding: "10px",
                borderBottom: "1px solid #888",
              }}
            >
              {t("privacy.termsOfUse")}
            </div>
            <div
              style={{
                height: "calc(90vh - 132px)",
                backgroundColor: "#FFF",
                overflowY: "scroll",
                padding: "7px",
              }}
              dangerouslySetInnerHTML={this.createMarkup(this.state.termsOfUse)}
            ></div>

            <MessageBox ref="instMessageBox" />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <div className="buttomCancel" onClick={(e) => this.refuse(e)}>
                {t("privacy.refuse")}
              </div>
              <div className="buttonConfirm" onClick={(e) => this.confirm(e)}>
                {t("privacy.accept")}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default translate()(ModalPrivacy);
